import { certificateConstants } from '../constants'

export const RegisterCertificate = (state = {}, action) => {
    switch (action.type) {
        case certificateConstants.REGISTER_TYPE01_REQUEST:
            return { loading: true, items: undefined, error: undefined }
        case certificateConstants.REGISTER_TYPE01_SUCCESS:
            return {
                loading: false,
                items: action.regCertData.Body,
                error: undefined
            }
        case certificateConstants.REGISTER_TYPE01_FAILURE:
            return { loading: false, items: undefined, error: action.error }
        case certificateConstants.REGISTER_TYPE02_REQUEST:
            return { loading: true, items: undefined, error: undefined }
        case certificateConstants.REGISTER_TYPE02_SUCCESS:
            return {
                loading: false,
                items: action.regCertUpdData.Body,
                error: undefined
            }
        case certificateConstants.REGISTER_TYPE02_FAILURE:
            return { loading: false, items: undefined, error: action.error }
        default:
            return state
    }
}

export const DocumentCertificate = (state = {}, action) => {
    switch (action.type) {
        case certificateConstants.GETDOCUMENT_REQUEST:
            return {
                loading: true,
                items: undefined,
                error: undefined
            }
        case certificateConstants.GETDOCUMENT_SUCCESS:
            return {
                loading: false,
                items: action.getDocCertData.Body,
                error: undefined
            }
        case certificateConstants.GETDOCUMENT_FAILURE:
            return { loading: false, items: undefined, error: action.error }
        default:
            return state
    }
}